import React from 'react';
import {
  TextField,
  Show as RaShow,
  SimpleShowLayout,
  useGetIdentity,
  FunctionField,
  DeleteButton,
  DateField,
  BooleanField,
} from 'react-admin';
import { withPermissions } from '../../components/hoc/WithPermissions';
import { usePageTitle } from '../../components/usePageTitle';
import { USER_ROLE } from '../../constants/statuses';

const Show = (props) => {
  usePageTitle(props);
  const { loading: identityLoading } = useGetIdentity();

  if (identityLoading) {
    return null;
  }

  return (
    <RaShow {...props}>
      <SimpleShowLayout>
        <TextField source="id" />
        <TextField source="fullName" />
        <TextField source="email" />
        <FunctionField label="Roles" render={(record) => record.roles.join(', ')} />
        <TextField source="type" />
        <TextField source="telegram" />
        <TextField source="pstid" label="PST ID" />
        <TextField
          source="provider_transaction_sum"
          label="Provider transaction sum"
        />
        <TextField source="cards_count" label="Cards count" />
        <TextField source="money_requests_count" label="Money requests count" />
        <TextField source="transaction_count" label="Transaction count" />
        <BooleanField source="is_deleted" label="Is deleted" />
        <DateField source="createdAt" />
        <DateField source="updatedAt" />
        <DeleteButton />
      </SimpleShowLayout>
    </RaShow>
  );
};

export default withPermissions(
  Show,
  null,
  [USER_ROLE.SUPER_ADMIN],
);
